module.exports = __webpack_public_path__ + "static/media/482.75ad4094.webp";